$(document).on('click', '.language-selector', function(event) {
    const target = $(this);
    
    target.toggleClass('--open');
});